var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#383866"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8136 6.17085C12.0621 6.39866 12.0621 6.76801 11.8136 6.99581L7.99543 10.4958C7.74692 10.7236 7.34399 10.7236 7.09548 10.4958L5.18639 8.74581C4.93787 8.51801 4.93787 8.14866 5.18639 7.92085C5.4349 7.69305 5.83783 7.69305 6.08634 7.92085L7.54545 9.25838L10.9137 6.17085C11.1622 5.94305 11.5651 5.94305 11.8136 6.17085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.02080923df44a5cdf3999092cb6b3298.svg";
export { ForwardRef as ReactComponent };